import { render, staticRenderFns } from "./commentinput.vue?vue&type=template&id=64d3ed46&scoped=true"
import script from "./commentinput.vue?vue&type=script&lang=js"
export * from "./commentinput.vue?vue&type=script&lang=js"
import style0 from "./commentinput.vue?vue&type=style&index=0&id=64d3ed46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d3ed46",
  null
  
)

export default component.exports